export default function ValueSection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-secondary-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-foreground-800 bg-background-50 rounded-full">
            Trusted by Thousands
          </span>
        </div>

        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 tracking-tight leading-tight max-w-2xl">
          Why Thousands of Users Choose ItaobuySpreadsheet
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mt-12">
          <div className="flex flex-col gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
              <i className="ri-flashlight-line text-xl text-primary-600"></i>
            </div>
            <h3 className="text-base font-semibold text-foreground-950">Fast Product Discovery</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Find products faster through structured spreadsheets instead of manual browsing across dozens of sites.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
              <i className="ri-scales-3-line text-xl text-accent-600"></i>
            </div>
            <h3 className="text-base font-semibold text-foreground-950">Easier Comparison</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Compare products side by side with organized data — much simpler than traditional shopping agents.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
              <i className="ri-user-smile-line text-xl text-primary-600"></i>
            </div>
            <h3 className="text-base font-semibold text-foreground-950">Beginner-Friendly</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Intuitive interface and step-by-step guides designed for users of all experience levels.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
              <i className="ri-refresh-line text-xl text-accent-600"></i>
            </div>
            <h3 className="text-base font-semibold text-foreground-950">Updated Lists</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Regularly refreshed curated product lists ensure you always have access to the latest data.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mt-14">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-extrabold text-primary-600">10K+</div>
            <div className="text-sm text-foreground-600 mt-2">Active Users</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-extrabold text-primary-600">50K+</div>
            <div className="text-sm text-foreground-600 mt-2">Products Listed</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-extrabold text-primary-600">14</div>
            <div className="text-sm text-foreground-600 mt-2">Categories</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-extrabold text-primary-600">30-60%</div>
            <div className="text-sm text-foreground-600 mt-2">Average Savings</div>
          </div>
        </div>
      </div>
    </section>
  );
}